export const mgPlatformTriangleIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" fill="none"><path d="M5 0L0 10H10L5 0Z" fill="currentColor"/></svg>`,
  name: 'triangle'
}
